import Vue from 'vue'
import { FETCH_ROLES, FETCH_ADMINS, FETCH_ENTITLEMENTS, CLEAR } from './Entitlements.mutation-types'

export default {
  [FETCH_ROLES] (state, roles) {
    Vue.set(state, 'roles', {})
    roles.forEach(role => {
      Vue.set(state.roles, role.id, role)
    })
  },

  [FETCH_ADMINS] (state, admins) {
    Vue.set(state, 'admins', {})
    admins.forEach(admin => {
      Vue.set(state.admins, admin.id, admin)
    })
  },

  [FETCH_ENTITLEMENTS] (state, entitlements) {
    Vue.set(state, 'entitlements', {})
    Vue.set(state, 'entitlements', entitlements)
  },

  [CLEAR] (state) {
    Vue.set(state, 'roles', {})
    Vue.set(state, 'admins', {})
    Vue.set(state, 'entitlements', {})
  }
}
